import { ReactElement } from 'react';
import { Download } from 'lucide-react';
import { styled } from 'styled-components';

const Button = styled.span`
  cursor: pointer;
  color: #1890ff;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    color: #40a9ff;
  }
`;

interface Props {
  onClick: () => void;
  label?: string;
}

const DownloadButton = ({ onClick, label = '.txt' }: Props): ReactElement => {
  return (
    <Button onClick={onClick}>
      <Download size={14} /> {label}
    </Button>
  );
};

export default DownloadButton;
